import { X } from 'lucide-react';

import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

interface Props {
  name?: string;
  children?: React.ReactNode;
  onClose?: () => void;
  closeButtonTop?: boolean;
}

const TooltipContentWithCloseButton = ({ name, children, onClose, closeButtonTop }: Props) => {
  const { base, text, closeIcon } = styles({ closeButtonTop });

  return (
    <div className={base()}>
      {children || <Text className={text()}>{name}</Text>}
      <button aria-label="close" onClick={onClose} type="button">
        <X size={14} className={closeIcon()} />
      </button>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-center',
    text: 'mb-0',
    closeIcon: 'ml-1 hover:text-errorDark',
  },
  variants: {
    closeButtonTop: {
      true: {
        base: 'items-start',
        closeIcon: 'mt-1.5',
      },
    },
  },
});

export { TooltipContentWithCloseButton };
